import axiosInstance from './axiosInstance';
import type { 
    CommunicationChannel, 
    CreateCommunicationChannelDto, 
    UpdateCommunicationChannelDto 
} from '../types/communication-channel';

export const communicationChannelsApi = {
    async getWorkerChannels(workerId: string): Promise<CommunicationChannel[]> {
        const response = await axiosInstance.get<CommunicationChannel[]>(
            `/workers/${workerId}/communication-channels`
        );
        return response.data;
    },

    async getChannel(channelId: number): Promise<CommunicationChannel> {
        const response = await axiosInstance.get<CommunicationChannel>(
            `/workers/communication-channels/${channelId}`
        );
        return response.data;
    },

    async createChannel(
        workerId: string, 
        data: CreateCommunicationChannelDto
    ): Promise<CommunicationChannel> {
        const response = await axiosInstance.post<CommunicationChannel>(
            `/workers/${workerId}/communication-channels`,
            data
        );
        return response.data;
    },

    async updateChannel(
        channelId: number, 
        data: UpdateCommunicationChannelDto
    ): Promise<CommunicationChannel> {
        const response = await axiosInstance.put<CommunicationChannel>(
            `/workers/communication-channels/${channelId}`,
            data
        );
        return response.data;
    },

    async setPrimaryChannel(channelId: number): Promise<CommunicationChannel> {
        const response = await axiosInstance.put<CommunicationChannel>(
            `/workers/communication-channels/${channelId}/set-primary`,
            {}
        );
        return response.data;
    },

    async deleteChannel(channelId: number): Promise<void> {
        await axiosInstance.delete(`/workers/communication-channels/${channelId}`);
    }
};